import React from 'react';
import './index.scss';

const BasicUnderLine = () => {
    return (
        <div className='basicUnderLine'></div>
    )
}

export { BasicUnderLine };